import { render, staticRenderFns } from "./programLecture.vue?vue&type=template&id=47328803"
import script from "./programLecture.vue?vue&type=script&lang=js"
export * from "./programLecture.vue?vue&type=script&lang=js"
import style0 from "./programLecture.vue?vue&type=style&index=0&id=47328803&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports